import { Component, OnInit, ChangeDetectorRef } from "@angular/core";
import { Router } from "@angular/router";
import { GlobalService } from "../../../services/global/global.service";
import { Observable } from "rxjs";
import { DMVStoreService } from "../../../services/dmv/dmv-store.service";
import { AgencyDmvConfigResponse } from "src/app/models/dmv/agency-config.response";
import { AgmMap, MapsAPILoader } from "@agm/core";
// import { GoogleMapsAPIWrapper } from '@agm/core/services';
// import {} from "@types/googlemaps";
import { PickupLocation } from "src/app/models/dmv/pickupLocation";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AppUtil } from "../../../utils/app.util";
import { MEGStoreService } from "src/app/services/meg/meg-store.service";
import { FormMaskConstants } from "src/app/constants/form-mask.constants";
import { MustMatch } from "src/app/_helper/must-match.validator";

declare var google: any;

@Component({
	selector: "app-pickup-in-person",
	templateUrl: "./pickup-in-person.component.html",
	styleUrls: ["./pickup-in-person.component.css"]
})
export class DmvPickupInPersonComponent implements OnInit {
	constructor(
		private router: Router,
		public globalService: GlobalService,
		public dmvStoreService: DMVStoreService,
		private formBuilder: FormBuilder,
		public megStoreService: MEGStoreService,
		private cd: ChangeDetectorRef,
		public mapsApiLoader: MapsAPILoader
	) {}
	public authorizedPersonPopup: boolean = false;
	public pickupLocation: PickupLocation;
	public errorMessage = "";
	public agencyConfig: AgencyDmvConfigResponse;
	public isloading: boolean = false;
	public submitted = false;
	public geocoder: any;
	public lat: number;
	public lng: number;
	public marker = [];
	public authorizedPersonForm: FormGroup;
	public name: string;
	public title: string;
	public subtitle: string;
	public supportKioskPickup: boolean;
	public email: string;
	public phone: string;
	public phoneMask = FormMaskConstants.PHONE_MASK;
	public locations: Array<PickupLocation>;
	ngOnInit() {
		if (
			this.globalService.params &&
			this.globalService.params.deliveryMethodID
		) {
			this.globalService.params.deliveryMethodID = null;
		}
		this.dmvStoreService.agencyConfig$.subscribe(agencyConfig => {
			if (agencyConfig) {
				this.agencyConfig = agencyConfig;
			}
		});
		let registrationLength = 0;
		if (
			this.dmvStoreService.registrationsInCart.dmvRegistrations &&
			this.dmvStoreService.registrationsInCart.dmvRegistrations.length > 0
		) {
			registrationLength =
				registrationLength +
				this.dmvStoreService.registrationsInCart.dmvRegistrations.length;
		}

		if (this.globalService.supportKioskPickup === undefined) {
			if (
				this.agencyConfig.agencyDmvConfig.supportKioskPickup &&
				registrationLength < this.agencyConfig.agencyDmvConfig.kioskPickupCap
			) {
				this.supportKioskPickup = true;
			} else {
				this.supportKioskPickup = false;
			}
		} else {
			this.supportKioskPickup = this.globalService.supportKioskPickup;
		}

		AppUtil.log("DmvPickupInPersonComponent ngOnInit() == >");
		this.title = "Pickup Locations For Renewal Documents";
		this.subtitle = this.supportKioskPickup
			? this.agencyConfig.agencyDmvConfig.pickupPageSubtitleTextKiosk
			: this.agencyConfig.agencyDmvConfig.pickupPageSubtitleTextStandard;
		if (this.supportKioskPickup) {
			const locationArray = this.agencyConfig.agencyDmvConfig.pickupLocations;
			this.locations = locationArray.filter(item => {
				return item.hasKiosk;
			});
		} else {
			this.locations = this.agencyConfig.agencyDmvConfig.pickupLocations;
		}

		this.mapsApiLoader.load().then(() => {
			this.geocoder = new google.maps.Geocoder();
			this.findLocation(this.agencyConfig.agencyDmvConfig.mapCenterZipCode);
		});

		if (!this.supportKioskPickup) {
			this.pickupLocation = this.dmvStoreService.registrationsInCart
				.pickupInPerson
				? this.dmvStoreService.registrationsInCart.pickupInPerson.pickupLocation
				: null;
			this.name = this.dmvStoreService.registrationsInCart.pickupInPerson
				? this.dmvStoreService.registrationsInCart.pickupInPerson
						.authorizedPerson
				: null;
			this.authorizedPersonForm = this.formBuilder.group({
				name: [this.name],
				personNameCheck: [this.name ? true : false]
			});
		} else {
			const emailAddressRegex = new RegExp(
				this.megStoreService.configuration.megConfig.emailAddressRegex
			);

			this.email = this.dmvStoreService.registrationsInCart.pickupInPerson
				? this.dmvStoreService.registrationsInCart.pickupInPerson.email
				: null;

			this.authorizedPersonForm = this.formBuilder.group(
				{
					email: [
						this.email,
						[
							Validators.required,
							emailAddressRegex && Validators.pattern(emailAddressRegex)
						]
					],
					confirmEmail: [
						this.email,
						[
							Validators.required,
							emailAddressRegex && Validators.pattern(emailAddressRegex)
						]
					]
				},
				{
					validator: [MustMatch("email", "confirmEmail", true)]
				}
			);
		}
		this.cd.detectChanges();
	}
	public changepersonNameCheck(event) {
		if (event.target.checked) {
			this.authorizedPersonForm.controls.name.setValidators([
				Validators.required,
				Validators.pattern(/^[^<=+>:;\/\\@\{\}\[\]?]*$/)
			]);
		} else {
			this.authorizedPersonForm.controls.name.setValidators(null);
		}
		this.authorizedPersonForm.controls.name.updateValueAndValidity();
	}

	// public changePhoneCheck(event) {
	// 	if (event.target.checked) {
	// 		this.authorizedPersonForm.controls.phone.setValidators([
	// 			Validators.required,
	// 			Validators.pattern(
	// 				/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4}$/
	// 			)
	// 		]);
	// 	} else {
	// 		this.authorizedPersonForm.controls.phone.setValidators(null);
	// 	}
	// 	this.authorizedPersonForm.controls.phone.updateValueAndValidity();
	// }

	// public changeEmailCheck() {

	// 		const emailAddressRegex = new RegExp(
	// 			this.megStoreService.configuration.megConfig.emailAddressRegex
	// 		);
	// 		this.authorizedPersonForm.controls.email.setValidators([
	// 			Validators.required,
	// 			emailAddressRegex && Validators.pattern(emailAddressRegex)
	// 		]);

	// 	this.authorizedPersonForm.controls.email.updateValueAndValidity();
	// }
	public get f() {
		return this.authorizedPersonForm.controls;
	}

	public findLocation(address) {
		AppUtil.log("DmvPickupInPersonComponent findLocation() == >", address);
		if (!this.geocoder) {
			this.geocoder = new google.maps.Geocoder();
		}

		this.geocoder.geocode(
			{
				address: address
			},
			(results, status) => {
				if (status === google.maps.GeocoderStatus.OK) {
					// decompose the result
					//	map.setCenter(results[0].geometry.location);
					this.lat = results[0].geometry.location.lat();
					this.lng = results[0].geometry.location.lng();
					const map = new google.maps.Map(document.getElementById("map"), {
						zoom: this.agencyConfig.agencyDmvConfig.mapZoomFactor
							? this.agencyConfig.agencyDmvConfig.mapZoomFactor
							: 9,
						center: { lat: this.lat, lng: this.lng }
					});

					let i = 1;
					this.locations.forEach(location => {
						this.marker[i] = new google.maps.Marker({
							optimized: false,
							position: new google.maps.LatLng(
								location.latitude,
								location.longitude
							),
							label: {
								text: i + "",
								color: "black",
								fontSize: "18px",
								fontWeight: "bold"
							},
							map: map,
							text_color: "#ffffff"
						});

						if (
							this.pickupLocation &&
							this.pickupLocation.locationID === location.locationID
						) {
							this.marker[i].setIcon({
								url:
									this.globalService.staticResourceURL +
									"assets/images/map-marker-green.svg",
								labelOrigin: new google.maps.Point(28, 20),
								scaledSize: new google.maps.Size(56, 56),
								size: new google.maps.Size(56, 56)
							});
						} else {
							this.marker[i].setIcon({
								url:
									this.globalService.staticResourceURL +
									"assets/images/map-marker-blue.svg",
								labelOrigin: new google.maps.Point(28, 20),
								scaledSize: new google.maps.Size(56, 56),
								size: new google.maps.Size(56, 56)
							});
						}
						const _this = this;
						this.marker[i].addListener("click", function() {
							const ind = Number(this.label.text) - 1;
							if (this.icon.url.indexOf("map-marker-blue") > -1) {
								_this.addInCart(null, ind);
							} else {
								_this.removeInCart(null, ind);
							}
						});
						i = i + 1;
					});

					this.cd.markForCheck();
				} else {
					alert("Sorry, this search produced no results.");
				}
			}
		);
	}
	public highlightMarker(index) {
		AppUtil.log("DmvPickupInPersonComponent highlightMarker() == >", index);
		for (let i = 1; i <= this.marker.length; i++) {
			if (this.marker[i]) {
				this.marker[i].setIcon({
					url:
						this.globalService.staticResourceURL +
						"assets/images/map-marker-blue.svg",
					labelOrigin: new google.maps.Point(28, 20),
					scaledSize: new google.maps.Size(56, 56),
					size: new google.maps.Size(56, 56)
				});
			}
		}
		if (index !== null) {
			const ind = index + 1;
			if (ind) {
				this.marker[ind].setIcon({
					url:
						this.globalService.staticResourceURL +
						"assets/images/map-marker-green.svg",
					labelOrigin: new google.maps.Point(28, 20),
					scaledSize: new google.maps.Size(56, 56),
					size: new google.maps.Size(56, 56)
				});
			}
		}
	}
	public isInCart(location) {
		let val = false;
		if (
			this.pickupLocation &&
			this.pickupLocation.locationID === location.locationID
		) {
			val = true;
		}
		AppUtil.log("DmvPickupInPersonComponent isInCart() == >", val);
		return val;
	}
	public removeInCart(location, index) {
		if (!this.supportKioskPickup) {
			this.pickupLocation = null;
			this.highlightMarker(null);
			this.cd.detectChanges();
		}
	}
	public addInCart(location, index) {
		if (!this.supportKioskPickup) {
			if (location === null) {
				location = this.locations[index];
			}
			AppUtil.log(
				"DmvPickupInPersonComponent addInCart() == >",
				location,
				index
			);
			this.errorMessage = "";

			this.pickupLocation = location;

			this.highlightMarker(index);
			this.cd.detectChanges();
		}
	}
	public goBack() {
		AppUtil.log(
			"DmvPickupInPersonComponent goBack() == >",
			this.dmvStoreService.routeFrom
		);
		if (
			this.dmvStoreService.routeFrom &&
			this.dmvStoreService.routeFrom.from !== "dmv-manual-renew" &&
			this.dmvStoreService.routeFrom.from !== "dmv-duplicate" &&
			!this.agencyConfig.agencyDmvConfig.allowPickup
		) {
			this.router.navigate([this.dmvStoreService.routeFrom.from], {
				skipLocationChange: true
			});
		} else {
			if (
				this.dmvStoreService.registrationsInCart.firstIteration ||
				(this.dmvStoreService.routeFrom &&
					this.dmvStoreService.routeFrom.from === "dmv-review-cart")
			) {
				this.router.navigate(["dmv-pickup-method"], {
					skipLocationChange: true
				});
			} else {
				this.router.navigate(["dmv-customize-order"], {
					skipLocationChange: true
				});
			}
		}
	}
	public openAuthorizedPerson() {
		this.authorizedPersonPopup = true;
	}
	public closeAuthorizedPerson() {
		this.authorizedPersonPopup = false;
	}
	public updateAuthorizedPerson(event) {
		AppUtil.log(
			"DmvPickupInPersonComponent updateAuthorizedPerson() == >",
			event
		);
		this.authorizedPersonPopup = false;
		this.errorMessage = "";
		if (!this.dmvStoreService.registrationsInCart.pickupInPerson) {
			this.dmvStoreService.registrationsInCart.pickupInPerson = {};
		}
		this.dmvStoreService.registrationsInCart.pickupInPerson.pickupLocation = this.pickupLocation;
		this.dmvStoreService.registrationsInCart.pickupInPerson.authorizedPerson =
			event.name;
		this.dmvStoreService.registrationsInCart.firstIteration = false;
		this.router.navigate(["dmv-review-cart"], { skipLocationChange: true });
	}
	public continue() {
		AppUtil.log(
			"DmvPickupInPersonComponent continue() == > this.pickupLocation===",
			this.pickupLocation
		);
		this.submitted = true;

		// if (
		// 	this.supportKioskPickup &&
		// 	!this.authorizedPersonForm.controls.textMessageCheck.value &&
		// 	!this.authorizedPersonForm.controls.emailCheck.value
		// ) {
		// 	return;
		// }
		if (this.authorizedPersonForm.invalid) {
			console.log("insuranceForm.invalid");

			return;
		}
		if (this.supportKioskPickup) {
			this.dmvStoreService.registrationsInCart.mailingAddress = undefined;
			this.dmvStoreService.registrationsInCart.pickupInPerson = {};

			this.dmvStoreService.registrationsInCart.pickupInPerson.email = this.authorizedPersonForm.controls.email.value;

			this.dmvStoreService.registrationsInCart.firstIteration = false;
			this.globalService.supportKioskPickup = this.supportKioskPickup;
			this.router.navigate(["dmv-review-cart"], { skipLocationChange: true });
			console.log("location added");
			return;
		}

		if (this.pickupLocation) {
			this.errorMessage = "";
			this.dmvStoreService.registrationsInCart.mailingAddress = undefined;
			if (!this.dmvStoreService.registrationsInCart.pickupInPerson) {
				this.dmvStoreService.registrationsInCart.pickupInPerson = {};
			}
			this.dmvStoreService.registrationsInCart.pickupInPerson.pickupLocation = this.pickupLocation;
			if (this.authorizedPersonForm.controls.personNameCheck.value) {
				this.dmvStoreService.registrationsInCart.pickupInPerson.authorizedPerson = this.authorizedPersonForm.controls.name.value;
			} else {
				this.dmvStoreService.registrationsInCart.pickupInPerson.authorizedPerson = null;
			}

			this.dmvStoreService.registrationsInCart.firstIteration = false;

			this.router.navigate(["dmv-review-cart"], { skipLocationChange: true });
			console.log("location added");
		} else {
			this.errorMessage = "Please select a pickup location.";
			window.scrollTo(0, 0);
		}
	}
}
